import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Tooltip,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDeDetalhe } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { enumSituacaoAposta, ILstDrop, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { DataGrid, GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { ApostaService, IDadosClassificacao, IDadosMinhasApostas } from "../../shered/services/api/apostas/ApostasService";
import dayjs from "dayjs";
import { useVForm } from "../../shered/forms";
import { Cancel } from "@mui/icons-material";

export const ListagemDeMinhasApostas: React.FC = () => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [semImagemFranquia, setSemImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");    
    const [minhasApostasRows, setMinhasApostasRows] = useState<IDadosMinhasApostas[]>([]);    
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);    

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const columnsMinhasApostas: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'codigo_Jogo_NBA',
            headerName: "",
            minWidth: UtilidadeService.isMobile() ? 90 : 100,
            maxWidth: UtilidadeService.isMobile() ? 90 : 100,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'right',            
        },
        {
            field: 'logo_Franquia_Mandante',
            headerName: "JOGO",
            flex: 1,

            minWidth: UtilidadeService.isMobile() ? 160 : 210,
            maxWidth: UtilidadeService.isMobile() ? 160 : 210,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                            justifyContent: "center",
                            alignSelf: "center"
                        }}
                    >
                        <Grid size={12} container
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignSelf: "center",
                                textAlign: "center",
                                verticalAlign: "center"


                            }}>
                            <Grid size={12} sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignSelf: "center",
                                textAlign: "center",
                                verticalAlign: "center"


                            }}>
                                {<Tooltip title={params.row.nome_Franquia_Mandante}><img src={params.row.logo_Franquia_Mandante === null ? semImagemFranquia : params.row.logo_Franquia_Mandante} width={45} height={50} /></Tooltip>}
                                <Grid size={2} sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignSelf: "center",
                                    textAlign: "center",
                                    verticalAlign: "center",
                                    marginLeft: "5px",
                                    marginRight: "5px",


                                }}>X</Grid>
                                {<Tooltip title={params.row.nome_Franquia_Visitante}><img src={params.row.logo_Franquia_Visitante === null ? semImagemFranquia : params.row.logo_Franquia_Visitante} width={45} height={50} /></Tooltip>}
                            </Grid>
                        </Grid>
                    </Box>
                );
            },
        },
        {
            field: 'data_Jogo',
            headerName: "DATA JOGO",
            flex: 1,

            minWidth: UtilidadeService.isMobile() ? 60 : 160,
            maxWidth: UtilidadeService.isMobile() ? 60 : 160,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
        },
        {
            field: 'escolha_Mandante',
            headerName: 'LOGO',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 80,
            maxWidth: 80,
            editable: false,
            sortable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => <img src={params.value ? params.row.logo_Franquia_Mandante === null ? semImagemFranquia : params.row.logo_Franquia_Mandante : params.row.logo_Franquia_Visitante === null ? semImagemFranquia : params.row.logo_Franquia_Visitante} width={45} height={50} />,
        },
        {
            field: 'nome_Franquia_Mandante',
            headerName: 'FRANQUIA',
            flex: 1,
            minWidth: 180,
            sortable: UtilidadeService.isMobile() ? false : true,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {params.value ? params.row.nome_Franquia_Mandante === null ? semImagemFranquia : params.row.nome_Franquia_Mandante : params.row.nome_Franquia_Visitante === null ? semImagemFranquia : params.row.nome_Franquia_Visitante}
                    </Box>
                );
            },
        },
        {
            field: 'dtCriacao',
            headerName: 'APOSTA',
            width: 190,
            headerClassName: 'super-app-theme--header',
            valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY HH:mm'),
            headerAlign: "center",
            align: "center"
        },
        {
            field: 'situacao',
            headerName: 'SITUAÇÃO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 120 : 140,
            maxWidth: UtilidadeService.isMobile() ? 120 : 160,
            sortable: UtilidadeService.isMobile() ? false : true,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null ? enumSituacaoAposta.find(f => f.codigo === params.value)?.label : enumSituacaoAposta.find(f => f.codigo === 1)?.label
        },
        {
            field: 'actions',
            headerName: 'AÇÃO',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            flex: 1,
            sortable: false,
            minWidth: UtilidadeService.isMobile() ? 65 : 90,
            maxWidth: UtilidadeService.isMobile() ? 65 : 100,

            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Cancelar"><Cancel sx={{ color: params.row.situacao === 1 ? "#E91309" : "auto" }} /></Tooltip>}
                    label="Cancelar"
                    onClick={() => handleCancelarAposta(params.row.codigo)}
                   // disabled={params.row.situacao !== 1}

                />
            ]
        }

    ];

    const handleCancelarAposta = (codigo: number) => {
        setShowModalEvent(true);
        setDadosModalEvent({
            acao: true,
            label: "Cancelar Aposta",
            tipo: "info",
            mensagem: `Deseja cancelar essa aposta?`,
            display: "none",
            titulo: "Atenção",
            evento: "cancelarAposta",
            info: {
                codigo: codigo,
                mensagemAdicional: "",
                style: { color: "red", fontWeight: "bold", wordWrap: "break-word", whiteSpace: "pre-line" }
            }
        });
        setRedirecionar("0");
    }

    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        debounce(() => {
            UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                .then((result) => {
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;

                });


            LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setSemImagem(user.imagem_Perfil !== null ? user.imagem_Perfil : semImagem);
                    setTemporadaFiltro(liga.codigo_Temporada);
                    carregarDados(liga.codigo_Temporada);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        })

    }, []);

    const carregarDados = async (codigoTemporada: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        await ApostaService.getMinhasApostas(codigoTemporada)
            .then((result) => {
                const dados = result.dado;
                setMinhasApostasRows(dados);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        carregarDados(e.target.value);

    }


    return (
        <LayoutBaseDePagina
            titulo={`Minhas Apostas`}
            showLogoImg={semImagemFranquia}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}
                    mostrarBotaoSalvar={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Classificação </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Minhas Apostas </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} style={{ paddingTop: "16px" }}>
                                {
                                    minhasApostasRows.length > 0 && (
                                        <Grid size={{ xs: 12, sm: 12 }} >
                                            <Box
                                                sx={{
                                                    height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                                    '& .super-app-theme--header': {
                                                        backgroundColor: theme.palette.common.black,
                                                        color: theme.palette.common.white,
                                                    },
                                                    '& .super-app.negative': {
                                                        color: 'red',
                                                        fontWeight: 'bold'
                                                    },
                                                    '& .super-app.positive': {
                                                        color: "#00e676",
                                                        fontWeight: '600',
                                                    },
                                                    '& .super-app-theme--cell': {
                                                        color: '#00e676',
                                                        fontWeight: '600',
                                                    },
                                                }}>
                                                <DataGrid
                                                    localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                    getRowId={(r) => r.codigo}
                                                    rows={minhasApostasRows}
                                                    columns={columnsMinhasApostas}
                                                    initialState={{
                                                        pagination: {
                                                            paginationModel: {
                                                                pageSize: 24,
                                                            },
                                                        },
                                                    }}
                                                    columnVisibilityModel={{
                                                        codigo: false,
                                                    }}
                                                    disableDensitySelector
                                                    disableVirtualization
                                                    pageSizeOptions={[12, 24, 32, 50, 75, 100]}
                                                    disableRowSelectionOnClick
                                                    disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                                    disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                                    hideFooter
                                                    sx={{
                                                        fontSize: UtilidadeService.isMobile() ? 10 : 16,
                                                    }}
                                                />
                                            </Box>
                                        </Grid>
                                    )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina >
    )
}


